import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HandleScreenBarService {
  screenTitlevisibility = true;
  public setscreenTitlevisibility = new BehaviorSubject<boolean>(this.screenTitlevisibility);
  castscreenTitlevisibility = this.setscreenTitlevisibility.asObservable();
  constructor(
    private router: Router,
  ) {}
  getScreenTitlevisibility(params: boolean) {
    this.screenTitlevisibility = params;
    this.setscreenTitlevisibility.next(this.screenTitlevisibility);
  }
}
